import classess from  './OktaSignInWidget.scss';

export function oktaTerminalChanges(){
    const loginErrorDiv = document.querySelector('#okta-sign-in.auth-container .o-form-error-container');
    if (loginErrorDiv && loginErrorDiv.innerText.includes("date and time")) {
        // adjust cancel button
        const modalCancel = document.getElementById('okta-widget-modal-cancel');
        if (modalCancel) {
            modalCancel.style.top = '4px';
        }
        // hide back to sign in 
        const signEle = document.querySelector("#okta-sign-in a.link.js-cancel");
        if (signEle) {
            signEle.style.display = 'none';
        }
        const identifierEle = document.querySelector("#okta-sign-in .identifier-container");
        if(identifierEle){
            identifierEle.style.display = 'none';
        }

        // create heading element
        let clockHeading = document.createElement('div');
        clockHeading.textContent = "Check Your Device's Date and Time";
        clockHeading.classList.add(classess.clockHeading);

        if (loginErrorDiv.parentNode) {
            loginErrorDiv.parentNode.insertBefore(clockHeading, loginErrorDiv);
        }
        // add Ok
        let okButton = document.createElement("button");
        okButton.textContent = "OK";
        okButton.type = "button";
        okButton.classList.add(classess.clockOkButton, classess.textSizeS);
        okButton.onclick = async () => {
            const signIn = document.querySelector('#okta-sign-in');
            if (signIn) {
                signIn.style.display = "none";
            }
            this.setState({ showloader: true });
            try {
                await this.widget.authClient.closeSession();
            } catch (err) {
                // error in closing session
            }
            this.loadOktaWidget();
        };
        loginErrorDiv.appendChild(okButton);
    }
}